// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"17d18da5","407":"d2458817","429":"51ec6ee4","962":"441d2541"}[chunkId] + ".chunk.js";
};